import getInitData from '../getInitData';

// @see ConsoleStoresInit.java
export default getInitData({
    env: null,
    release: null,
    stores: {
        setupPassword: {},
        console: {},
        customerSelect: {},
    },
});
